import {
  FC,
  FormEventHandler,
  FormHTMLAttributes,
  PropsWithChildren,
  useCallback,
} from 'react'

const Form: FC<FormProps> = (props) => {
  const { onSubmit, children, ...passingProps } = props

  const handleSubmit: FormEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault()
      const form = e.target as HTMLFormElement
      onSubmit(Object.fromEntries(new FormData(form)) as Fields)
    },
    [onSubmit]
  )

  return (
    <form onSubmit={handleSubmit} {...passingProps}>
      {children}
    </form>
  )
}

type FormProps = Pick<FormHTMLAttributes<HTMLFormElement>, 'id'> &
  PropsWithChildren & {
    onSubmit: (fields: Fields) => void
  }

type Fields = Record<string, string>

export { Form }
export type { Fields, FormProps }
